import { useQuery } from 'react-query';
import { getPatientNutrients } from '../api/getPatientNutrients';
import useNutrientDv from './useNutrientDv';
import { useNutrientsContext } from '../contexts/NutrientsContext';
import { formatNutrientData } from '../helpers/nutrientFormatHelpers';

const useNutrients = (options, type) => {
  // Handle both string (backward compatibility) and object formats
  const queryOptions = typeof options === 'string' ? { shareToken: options } : options;

  const { shareToken, workflowId } = queryOptions || {};

  // Create query identifier based on available parameters
  const queryIdentifier = shareToken ? `share_${shareToken}` : `workflow_${workflowId}`;

  const { state: { allNutrientsData, allNutrientsLoading } = {} } = useNutrientsContext();

  // useNutrientDv can handle both shareToken and workflowId
  const { data: nutrientDvData, isLoading: nutrientDvLoading } = useNutrientDv(queryOptions);

  // If we're in the context provider, fetch all data - but only if we have a shareToken
  // getPatientNutrients cannot use workflowId
  if (type === 'all') {
    const { data, isLoading, isRefetching, refetch } = useQuery(
      `nutrients_all_${queryIdentifier}`,
      () => (shareToken ? getPatientNutrients(shareToken) : null),
      {
        enabled: !!shareToken,
        refetchOnWindowFocus: false,
        staleTime: 3600000,
      },
    );

    const nutrientProfile = getNutrientData(data, type, nutrientDvData?.data);

    return {
      data: nutrientProfile,
      isLoading: isLoading || nutrientDvLoading || isRefetching,
      refetch,
    };
  }

  const nutrientProfile = formatNutrientData(allNutrientsData, type, nutrientDvData?.data);

  return {
    data: nutrientProfile,
    isLoading: allNutrientsLoading || nutrientDvLoading,
  };
};

export default useNutrients;
